<template>
	<nav class="booking-calendar-month-desktop-head hidden-xs hidden-sm">
		<div class="row">
			<!-- Select provider -->
			<div class="col-xs-7 margin-bottom-xs-1">
				<ToggleSelectProviderDesktop />
			</div>
			<!-- Select view type -->
			<div class="col-xs-5 text-right margin-bottom-xs-1">
				<SelectCalendarViewType />
			</div>
		</div>

		<div class="row">
			<SelectProvider />
		</div>

		<!-- Date info -->
		<div class="row">
			<div class="col-xs-5 margin-top-xs-1 margin-bottom-xs-2">
				<p class="capitalize margin-bottom-xs-0">
					{{ dates.active.monthName }}
					{{ year }}
				</p>
				<p class="margin-bottom-xs-0" v-if="activities.selected">
					Vald tjänst:
					<span v-html="activities.selected.activity_name"></span>
				</p>
			</div>
			<!-- Date navigation -->
			<div class="col-xs-7 margin-top-xs-1 margin-bottom-xs-2">
				<p class="text-align-right-md margin-bottom-xs-0">
					<a
						href="#"
						class="link-arrow-left margin-right-xs-1 capitalize"
						@click.prevent="setupActiveDates('back')"
						v-if="!dateIsInThePast"
						>{{ dates.active.previousMonth }}</a
					>
					<span class="capitalize"
						><strong>{{ dates.active.monthLongName }}</strong></span
					>
					<a
						href="#"
						class="link-arrow-right margin-left-xs-1 capitalize"
						@click.prevent="setupActiveDates('forward')"
						>{{ dates.active.nextMonth }}</a
					>
				</p>
			</div>
		</div>
	</nav>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ToggleSelectProviderDesktop from "./ToggleSelectProviderDesktop.vue";
import SelectProvider from "./SelectProvider.vue";
import SelectCalendarViewType from "./SelectCalendarViewType.vue";

export default {
	components: {
		ToggleSelectProviderDesktop,
		SelectProvider,
		SelectCalendarViewType,
	},
	computed: {
		...mapState(["ui", "dates", "activities", "providers", "activities"]),
		...mapGetters(["dateIsInThePast"]),
		/* We're doing this as a computed property because it caused issues when navigating to January 2021 in the month view - the calendar said "January 2020" instead */
		year() {
			if (this.dates.active.niceDate) {
				return this.dates.active.niceDate.substring(0, 4);
			}
			return this.dates.active.year;
		},
	},
	methods: {
		...mapActions([
			"setupActiveDates",
			"toggleSelectingProvider",
			"calendarViewType",
		]),
	},
};
</script>